import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NgbPaginationModule, NgbDropdownModule, NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {MergeModal} from './merge-modal/merge-modal';

const modals = [MergeModal];

@NgModule({
	declarations: [
		AppComponent,
		modals
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		NgbPaginationModule,
		FormsModule,
		NgbDropdownModule,
		NgbModalModule
	],
	providers: [],
	bootstrap: [AppComponent],
	entryComponents: [
		modals
	]
})
export class AppModule { }
